module.exports = __webpack_public_path__ + "img/logo2.e6e1be01.png";